import React from 'react';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';
import './DescriptionPopup.css';

const DescriptionPopup = () => {

  function close() {
    PopupStore.close(POPUPS_IDS.DESCRIPTION)
  }

  let name = store.scenario.name

  if(store.isGenericMeeting) name = store.t(store.genericMeeting.id, name)

  let desc = store.scenario.summary
  if(store.isGenericMeeting) desc = store.t(store.genericMeeting.id + "_summary", desc)

  return (
    <div className="overlay" onClick={close}>
      <div className="DescriptionPopup">
      <div className="title">
        <span dangerouslySetInnerHTML={{__html: name}} />
        <div className="close-button" onClick={close} />
      </div>
      <div className="content" dangerouslySetInnerHTML={{__html: desc}} />


      </div>
    </div>
  );
};

export default DescriptionPopup;
